import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";

const OfficeRemovalModal = ({ officeToRemove, onRemove, onClose }) => (
  <Modal
    show={Boolean(officeToRemove)}
    onHide={onClose}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[480px] tw-max-h-[90vh] tw-w-full"
  >
    <Modal.Header title={`Delete ${officeToRemove?.name || ""}?`} closeButton className="tw-mb-[23px]" />
    <div className="tw-flex">
      <Button
        onClick={() => {
          onClose();
        }}
        size="medium"
        schema="tertiary"
      >
        Cancel
      </Button>
      <div className="tw-flex-1" />
      <Button onClick={onRemove} size="medium" schema="warning">
        Yes, Delete
      </Button>
    </div>
  </Modal>
);

OfficeRemovalModal.propTypes = {
  officeToRemove: PropTypes.shape().isRequired,
  onRemove: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default OfficeRemovalModal;
